<template>
<div v-if="open" >
	<WindowForAlert :id="'editAccount'" :title="title" ref="addAccount" :size="'m'" >
		<div class="mt05x">
			<div class="ml1x mr1x pt05x pb05x taC inputWrap pb2x">
				<InputText verification='notEmpty' v-model="search"  class="w100pct dpIB bgContent" name="addAccountSearch" :placeholder="type == 1?getLanguageStr('phrase848','请输入商家名称'):getLanguageStr('crm39','请输入姓名/手机号/邮箱')" :clearBtn="true" ref="searchBox" :searchBtn="true" :fn="getAccountList" @AfterClear="getAccountList"></InputText>
			</div>
			<div class="posR"  v-show="existAccInfo.show">
				<Loading v-show="existAccInfo.loading"></Loading>
				<div>{{getLanguageStr('plant_detail239','搜索结果')}}：</div>
				<template v-if="type==1">
					 <div class="h20x-max lh20 ofH" v-show="existAccInfo.list.length" scroll>
						<ul class="curP_E">
							<li v-for="(item,index) in existAccInfo.list" :key="index" class="hoverBg pl1x pr1x" @click.stop="addAccount(item)">
								<div class="pb05x pt05x tableSys vaM_E" :class="{ 'bdSub-bottom':index < existAccInfo.list.length-1}">
                  <div class="w5x">
                     <div class="w4x h4x">
                    	  <Logo customClass='w4x h4x' :Logourl='item.org.logo'/>
                      </div>
                  </div>
									<div>
										<div class="fs12x mt05x">{{item.name}}</div>
									</div>
									<div class="w5x cSub taC" v-if='noshowEmp===false'>
										<div v-if="item.roleId" class="cSub">{{getLanguageStr('plant_detail149','已添加')}}</div>
										<button v-else type="button" class="fSub" :title="getLanguageStr('manage353','添加关系')">
											 <!-- @click="addRelative(item)" -->
												<Icon name="add" class="w1x h1x" :sizeBase="'m'"/>
										</button>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="h12x-min taC " v-if='noshowEmp===false' v-show="!existAccInfo.list.length">
						<div class="mt2x">{{getLanguageStr('phrase746','未搜索到结果，是否为此商家创建一个账号？')}}</div>
						<button type="button" permission-type="none" class="functionBtn sizeM w6x mt1x" @click="build">{{getLanguageStr('word1811','立即创建')}}</button>
					</div>
				</template>
				<template v-else>
					<div class="h20x-max lh20 ofH" v-show="existAccInfo.list.length" scroll>
						<ul class="curP_E">
							<li v-for="(item,index) in existAccInfo.list" :key="index" class="hoverBg pl1x pr1x" @click.stop="addAccount(item)">
								<div class="pb1x tableSys vaM_E" :class="{ 'bdSub-bottom':index < existAccInfo.list.length-1}">
                  <div class="w5x">
                    <div class="w4x h4x">
                        <Logo customClass='w4x h4x' :Logourl='item.userInfo.photo' :LogoType="'person'"/>
                    </div>
                  </div>
									<div>
										<template>
												<div class="fs12x mt05x" >{{item.name}}</div>
										</template>
										<div class="cSub vaM_E" v-if='noshowEmp===false'>
												<svg class="dvStatus dpIB mr05x fillMain fSub"><use xlink:href="#phone"></use></svg>{{item.userInfo.phoneNumber}}
										</div>
										<div class="cSub vaM_E" v-if='noshowEmp===false'>
												<svg class="dvStatus dpIB mr05x alpha-hight fillMain fSub"><use xlink:href="#email"></use></svg>{{item.userInfo.email}}
										</div>
									</div>
									<div class="w5x cSub taC" v-if='noshowEmp===false'>
											<div v-if="item.roleId" class="cSub">{{getLanguageStr('plant_detail149','已添加')}}</div>
											<button v-else type="button" class="fSub" :title="getLanguageStr('manage353','添加关系')">
													<Icon name="add" class="w1x h1x" :sizeBase="'m'"/>
											</button>
									</div>

								</div>
							</li>
						</ul>
					</div>
					<div class="h12x-min taC " v-if='noshowEmp===false' v-show="!existAccInfo.list.length">
						<div class="mt2x">{{getLanguageStr('phrase739','未搜索到结果，是否为他创建一个账号？')}}</div>
						<button type="button" permission-type="none" class="functionBtn sizeM w6x mt1x" @click="build">{{getLanguageStr('word1811','立即创建')}}</button>
					</div>
				</template>

			</div>
		</div>
	</WindowForAlert>
</div>
</template>

<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import InputText from '@/components/common/ui/InputText.vue'
import Loading from '@/components/common/ui/Loading'
import {AllOrgs, AllUsers} from '@/api/manage/externalRelative.js'
import { mapGetters } from 'vuex'
import Logo from '@/components/common/ui/Logo.vue';
export default {
  name: 'addAccount',
  components: {WindowForAlert, InputText, Loading,Logo},
  mounted () {
    lib.fillHeight()
    lib.setScroll($(this.$el).find('[scroll]'))
  },
  data () {
    return {
      open: false,
      search: '',
      title: '',
      stage,
      type: 1,
      accountList: [],
      existAccInfo: {
        show: false,
        loading: false,
        list: []
      }
    }
  },
  props: {
    noshowEmp: {
      type: Boolean,
      default: false
    },
    custitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo'
    })
  },
  methods: {
    getLanguageStr,
    show (type) {
      this.type = type
      this.reset()
      this.open = true
      this.$nextTick(() => {
        type == 1 ? this.title = getLanguageStr('cmd174', '添加已有商家') : this.title = getLanguageStr('word1688', '添加已有用户')
        if (this.custitle) {
          this.title = getLanguageStr('manage318', '选择商家')
        }
        this.$refs.addAccount.show({
          title: this.title
        })
        this.$refs.searchBox.reset()
        lib.setScroll($(this.$el).find('[scroll]'))
      })
    },
    reset () {
      this.open = false
      this.search = ''
      this.accountList = []
      this.existAccInfo = {
        show: false,
        loading: false,
        list: []
      }
    },
    getAccountList () {
      let language = stage.languageId
      this.existAccInfo.list = []
      if (!this.search) {
        return false
      }
      this.existAccInfo.show = true
      this.existAccInfo.loading = true
      let request = {
        'order.direction': 'ASC',
        'order.property': 'id',
        keyword: this.search,
        page: 1,
        size: 1000
      }
      if (this.type === 1) {
        AllOrgs(request).then(res => {
          if (res || res.data.length) {
            //     name:'赵海8',
            //     id:8,
            //     phone:'1321354',
            //     email:'454645@sqw.com',
            //     isAdd:false
            let existNameList = res.data.filter(el => el.nameList.length)
            existNameList.forEach((val, index) => {
              if (val.nameList.length == 1) {
                val.name = val.nameList[0].name
              } else {
                let FilterName = val.nameList.filter(el => el.language === language)
                if (FilterName.length) {
                  val.name = FilterName[0].name
                } else {
                  let filterEn = val.nameList.filter(el => el.language === 'en')
                  if (filterEn.length) {
                    val.name = filterEn[0].name
                  } else {
                    val.name = val.nameList[0].name
                  }
                }
              }
            })
            this.existAccInfo.list = existNameList.map(el => ({
              entityRel: el.entityRel,
              entityRelId: el.entityRel ? el.entityRel.id : '',
              name: el.org.name,
              id: el.org.id,
              isAdd: false,
              roleId: el.entityRel ? el.entityRel.roleId : '',
              org: el.org
            }))
            // let list = res.data.map(el => ({
            //   nameList: el.nameList,
            //   id: el.org.id,
            //   entityRelId: el.entityRel ? el.entityRel.id : '',
            //   roleId: el.entityRel ? el.entityRel.roleId : ''
            // }))
            // this.existAccInfo.list = list.filter(el => el.nameList.length)
            // this.existAccInfo.list.forEach((val, index) => {
            //   val.name = val.nameList.filter(el => el.language == language)
            // })
            let {total} = res
            this.pagination = {...this.pagination, ...{total}}
          }
          this.existAccInfo.loading = false
          this.$nextTick(() => {
            lib.fillHeight()
            lib.setScroll($(this.$el).find('[scroll]'))
          })
        }, error => {
          this.existAccInfo.loading = false
          lib.fillHeight()
          !_.isEmpty(error) && this.$notify(error)
        })
      } else {
        request.keywordType = 0
        AllUsers(request).then(res => {
          if (res || res.data.length) {
            this.existAccInfo.list = res.data.map(el => ({
              entityRel: el.entityRel,
              name: el.userInfo.name,
              id: el.userInfo.id,
              entityRelId: el.entityRel ? el.entityRel.id : '',
              roleId: el.entityRel ? el.entityRel.roleId : '',
              userInfo: el.userInfo
            }))
          }
          this.existAccInfo.loading = false
          this.$nextTick(() => {
            lib.fillHeight()
            lib.setScroll($(this.$el).find('[scroll]'))
          })
        }, error => {
          this.existAccInfo.loading = false
          lib.fillHeight()
          !_.isEmpty(error) && this.$notify(error)
        })
      }
    },
    addRelative (item) {
      if (item.id == this.userInfo.orgUser.orgId) {
        this.$notify(getLanguageStr('phrase747', '不允许添加自己'))
      } else {
        if (item.roleId) {
          this.hide()

          this.$emit('AddAccountChoose', item)
        } else {
          this.hide()
          this.$emit('AddRelative', item)
        }
      }
    },
    hide () {
      this.$refs.addAccount.hide()
      setTimeout(() => {
        this.open = false
      }, 500)
    },
    addAccount (item) { // 谁都能添加
      // console.log(item,this.userInfo)
      // if (item.id == this.userInfo.userInfo.id){
      // 	this.$notify(getLanguageStr('phrase747', '不允许添加自己'))
      // } else {
      if (item.roleId) {
        this.$emit('AddAccountChoose', item)
      } else {
        this.$emit('AddRelative', item)
      }
      this.hide()
      // }
    },
    build () {
      this.hide()
      this.$emit('BuildNewAccount', this.type)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/manage/account/SearchRelative.vue